<template>
	<div>
		<Tabs type="card">
			<TabPane label="回收设置" v-if="userInfo.role_type==1 || userInfo.role_type==4 ">
				<div style="margin-bottom: 30px;">
					<Button type="primary" @click="addRule">添加规则</Button>
				</div>
				<div>
					<Table :columns="columns1" :data="data1">
						<template slot-scope="{ row }" slot="timeType">
							<div>
								<div>
									<span v-if="row.apply_time >0 ">申请时间区间：{{ row.min_apply_time }} -- {{ row.apply_time }}天</span>
								</div>
								<div>
									<span v-if="row.remark_time >0">备注时间：{{ row.remark_time }}天</span>
								</div>
								<div>
									<span v-if="row.join_time >0">再分配时间：{{ row.join_time }}天</span>
								</div>
							</div>
						</template>
						<template slot-scope="{ row, index }" slot="action">
							<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id" @click="editClientRecoverSet">编辑</Button>
							<Button type="error" size="small" :data-id="row.id" @click="delClientRecoverSet">删除</Button>
						</template>
						<template slot-scope="{ row, index }" slot="is_open">
							<i-switch v-model="data1[index].is_open" size="large" @on-change="saveOpen($event, index)">
								<span slot="open">开</span>
								<span slot="close">关</span>
							</i-switch>
						</template>
					</Table>
				</div>
			</TabPane>
			<TabPane label="回收" v-if="userInfo.role_type==1 || userInfo.role_type==4 ">
				<div class="header">
					<div class="title">客户锁定设置</div>
				</div>
				<div class="multiple">
					<div class="child-div" style="width: 160px">员工最多可锁定客户数</div>
					<Input  v-model="myData.lock_nums" style="width: 100px ;margin: 0 20px;">
						<span slot="append">人</span>
					</Input>
				</div>
				<div class="multiple">
					<div class="child-div" style="width: 160px">员工客户库存限制数</div>
					<Input  v-model="myData.limit_nums" style="width: 100px ;margin: 0 20px;">
						<span slot="append">人</span>
					</Input>
				</div>
				<div class="multiple">
					<div class="child-div" style="width: 160px">员工最多可锁定客户时间</div>
					<Input  v-model="myData.lock_days" style="width: 100px ;margin: 0 20px;">
						<span slot="append">天</span>
					</Input>
				</div>
				<div class="multiple">
					<div class="child-div" style="width: 160px">员工查看手机号限制数</div>
					<Input  v-model="myData.look_nums" style="width: 100px ;margin: 0 20px;">
						<span slot="append">人</span>
					</Input>
				</div>
				<div class="multiple">
					<div class="child-div" style="width: 160px">公共池领取限制数</div>
					<Input  v-model="myData.pool_limit_nums" style="width: 100px ;margin: 0 20px;">
						<span slot="append">人</span>
					</Input>
				</div>
				<div class="header">
					<div class="save"><Button class="ivu-btn-circle" type="primary" @click="saveClientSet">保存</Button></div>
				</div>
				<div class="header">
					<div class="title">系统设置</div>
				</div>
				<div class="header" v-if="userInfo.role_type == 1 || userInfo.role_type == 4 ">
					<div class="save"><Button class="ivu-btn-circle" type="primary" @click="adminSet">系统重置</Button></div>
				</div>
			</TabPane>
			<TabPane label="基础设置" v-if="userInfo.role_type==1 || userInfo.role_type==4 ">
				<div class="header">
					<div class="title">客户锁定设置</div>
				</div>
				<div class="multiple">
					<div class="child-div" style="width: 160px">员工最多可锁定客户数</div>
					<Input  v-model="myData.lock_nums" style="width: 100px ;margin: 0 20px;">
						<span slot="append">人</span>
					</Input>
				</div>
				<div class="multiple">
					<div class="child-div" style="width: 160px">员工客户库存限制数</div>
					<Input  v-model="myData.limit_nums" style="width: 100px ;margin: 0 20px;">
						<span slot="append">人</span>
					</Input>
				</div>
				<div class="multiple">
					<div class="child-div" style="width: 160px">员工最多可锁定客户时间</div>
					<Input  v-model="myData.lock_days" style="width: 100px ;margin: 0 20px;">
						<span slot="append">天</span>
					</Input>
				</div>
				<div class="multiple">
					<div class="child-div" style="width: 160px">员工查看手机号限制数</div>
					<Input  v-model="myData.look_nums" style="width: 100px ;margin: 0 20px;">
						<span slot="append">人</span>
					</Input>
				</div>
				<div class="multiple">
					<div class="child-div" style="width: 160px">公共池领取限制数</div>
					<Input  v-model="myData.pool_limit_nums" style="width: 100px ;margin: 0 20px;">
						<span slot="append">人</span>
					</Input>
				</div>
				<div class="header">
					<div class="save"><Button class="ivu-btn-circle" type="primary" @click="saveClientSet">保存</Button></div>
				</div>
				<div class="header">
					<div class="title">系统设置</div>
				</div>
				<div class="header" v-if="userInfo.role_type == 1 || userInfo.role_type == 4 ">
					<div class="save"><Button class="ivu-btn-circle" type="primary" @click="adminSet">系统重置</Button></div>
				</div>
			</TabPane>
		</Tabs>	


		<Modal v-model="recoverRuleModal" title="自动分配规则" @on-ok="save">
			<div style="height: 600px; overflow-y: auto; overflow-x: hidden">
			<Form :model="formItem" :label-width="100">
				<FormItem label="规则名字">
					<Input v-model="formItem.name">
					</Input>
				</FormItem>
				<FormItem label="星级等于">
					<Select v-model="formItem.start" multiple>
						<Option v-for="item in rateList" :value="item.value" :key="item.value">
							{{ item.label }}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="状态等于">
					<Select v-model="formItem.status" multiple>
						<Option v-for="item in stateList" :value="item.value" :key="item.value">
							{{ item.label }}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="回收客户范围">
					<Select v-model="formItem.is_redistribute" multiple>
						<Option v-for="item in clientStatusList" :value="item.value" :key="item.value">
							{{ item.label }} 
						</Option>
					</Select>
				</FormItem>
				<FormItem label="是否包含锁定客户">
					<Select v-model="formItem.is_lock" multiple>
						<Option v-for="item in lockList" :value="item.value" :key="item.value">
							{{ item.label }} 
						</Option>
					</Select>
				</FormItem>
				<FormItem label="转移或分配">
					<Select v-model="formItem.give_out_type" >
						<Option value="1">分配</Option>
						<Option value="2">转移</Option>
					</Select>
				</FormItem>
				<FormItem>
					<div slot="label">
						<Tooltip placement="top" >
							申请时间区间
							<div slot="content" style="color: coral;">
								情况1：当只有最小申请时间存在的时候，为当天的零点到所填的数字往前推的天数，
								<br>
								如填最小申请时间为3，今天是12月5号，那么代表12月2号零点到12月5号零点的数据
								<br>
								情况2：只有最大申请时间时，那么时间应该是，执行日0点之前的数据到最大申请时间那天。
								<br>
								如最大申请时间填写30，那么应该往前推30天，如果今天是12月5号，那么这个代表11月5号0点，到12月5号0点之间的数据
								<br>
								情况3：两个都存在时，就是最小申请到最大申请的区间。如果填写2-30，今天是12月5号，那代表11月5号0点到12月3号0点之间的数据
								<br>
							</div>
						</Tooltip>
					</div>
					<Input v-model="formItem.min_apply_time" style="width: 150px" placeholder="最小申请时间">
					</Input>
					<span>--</span>
					<Input v-model="formItem.apply_time" style="width: 150px" placeholder="最大申请时间">
					</Input>
				</FormItem>
				<FormItem label="未跟进时间">
					<Input v-model="formItem.remark_time">
					<span slot="append">天内未添加备注</span>
					<Select v-model="remark_time_type" @on-change="remarkTimeTypeChange" slot="prepend"
						style="width: 80px">
						<Option value="1">昨天</Option>
						<Option value="3">近三天</Option>
						<Option value="7">近7天</Option>
						<Option value="15">近15天</Option>
						<Option value="">自定义</Option>
					</Select>
					</Input>
				</FormItem>
				<FormItem label="再分配时间">
					<Input v-model="formItem.join_time">
					<span slot="append">天以上</span>
					<Select v-model="join_time_type" @on-change="joinTimeTypeChange" slot="prepend" style="width: 80px">
						<Option value="1">昨天</Option>
						<Option value="3">近三天</Option>
						<Option value="7">近7天</Option>
						<Option value="15">近15天</Option>
						<Option value="">自定义</Option>
					</Select>
					</Input>
				</FormItem>
				<FormItem label="执行时间">
						<TimePicker :steps="[1, 1, 60]" placeholder="Select time" v-model="formItem.execution_time"></TimePicker>
				</FormItem>
				<FormItem label="不回收时间">
					<CheckboxGroup v-model="formItem.not_recover_time">
						<Checkbox label="周六"></Checkbox>
						<Checkbox label="周日"></Checkbox>
						<Checkbox label="节假日"></Checkbox>
					</CheckboxGroup>
				</FormItem>
				<FormItem label="是否开启">
					<i-switch v-model="formItem.is_open" size="large">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</FormItem>
				<FormItem label="是否回收到公共池">
					<i-switch v-model="formItem.is_recover_to_pool" size="large">
						<span slot="open">是</span>
						<span slot="close">否</span>
					</i-switch>
				</FormItem>
				<FormItem label="提取忽略员工">
					<div slot="label">
						<Tooltip placement="top">
							提取忽略员工
							<div slot="content">
								如果勾选，则勾选员工数据不进行<br>
								提取分配
							</div>
						</Tooltip>
					</div>
					<Checkbox :value="checkAll" @click.prevent.native="handleCheckAll" :indeterminate="indeterminate">
						<span>全选</span>
					</Checkbox>
					<CheckboxGroup v-model="formItem.ignore_uid" @on-change="checkAllGroupChange">
						<Checkbox v-for="item in userList" :label="item.id"><span>{{item.name}}</span></Checkbox>
					</CheckboxGroup>
				</FormItem>
				<FormItem label="分配忽略员工">
					<div slot="label">
						<Tooltip placement="top">
							分配忽略员工
							<div slot="content">
								如果勾选，则勾选员工不接收<br>
								重新打乱分配的数据
							</div>
						</Tooltip>
					</div>
					<Checkbox :value="checkAllDistribute" @click.prevent.native="handleCheckAllForDistribute"
						:indeterminate="indeterminate_distribute">
						<span>全选</span>
					</Checkbox>
					<CheckboxGroup v-model="formItem.distribute_ignore_uid"
						@on-change="checkAllGroupChangeForDistribute">
						<Checkbox v-for="item in userList" :label="item.id"><span>{{item.name}}</span></Checkbox>
					</CheckboxGroup>
				</FormItem>
			</Form>				
			</div>

		</Modal>
	</div>
</template>

<script>
	import {
		getClientSet,
		saveClientSet,
		getClientRecoverSet,
		getClientRecoverSetList,
		saveClientRecoverSetOpen,
		saveClientRecoverSet,
		delClientRecoverSet
	} from "../../api/task";
	import {
		getTeamList,
		setIsFlush
	} from '@/api/user'
	import {
		mapGetters
	} from "vuex";

	export default {
		name: 'RecoverSet',
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.loadData();
		},
		data() {
			return {
				recoverRuleModal: false,
				apply_time_type: '',
				remark_time_type: '',
				join_time_type: '',
				formItem: {
					is_open: false,
					is_recover_to_pool:false,
					name: '',
					start: [],
					status: [],
					ignore_uid: [],
					distribute_ignore_uid: [],
					apply_time: '',
					min_apply_time:'',
					remark_time: '',
					join_time: '',
					execution_time:'',
					give_out_type:'',
					is_lock:[],
					not_recover_time:[],
				},
				rateList: [{
						value: 0,
						label: '0星'
					},
					{
						value: 1,
						label: '1星'
					},
					{
						value: 2,
						label: '2星'
					},
					{
						value: 3,
						label: '2星+'
					},
					{
						value: 4,
						label: '3星'
					},
					{
						value: 5,
						label: '4星'
					},
				],
				timeTypeList: [{
						value: 1,
						label: '未跟进时间'
					},
					{
						value: 2,
						label: '再分配时间'
					},
					{
						value: 3,
						label: '申请时间'
					}
				],
				clientStatusList: [{
						value: 0,
						label: '我的客户'
					},
					{
						value: 1,
						label: '再分配客户'
					}
				],
				lockList: [{
						value: 1,
						label: '已锁定客户'
					},
					{
						value: -1,
						label: '未锁定客户'
					}
				],
				stateList: [{
						value: 1,
						label: '未处理',
						is_true: 0
					},
					{
						value: 2,
						label: '待跟进',
						is_true: 0
					},
					{
						value: 3,
						label: '邀约中',
						is_true: 0
					},
					{
						value: 6,
						label: '上门未签约',
						is_true: 0
					},
					{
						value: 7,
						label: '已签约',
						is_true: 0
					},
					{
						value: 8,
						label: '进件中',
						is_true: 0
					},
					{
						value: 9,
						label: '银行拒绝',
						is_true: 0
					},
					{
						value: 13,
						label: '已回款',
						is_true: 0
					},
					{
						value: 14,
						label: '资质不符',
						is_true: 0
					},
					{
						value: 15,
						label: '捣乱申请',
						is_true: 0
					},
					{
						value: 16,
						label: '外地申请',
						is_true: 0
					},
					{
						value: 17,
						label: '重复申请',
						is_true: 0
					},
					{
						value: 18,
						label: '短信申请',
						is_true: 0
					}
				],
				columns1: [{
						"title": "序号",
						"key": "id",
						"align": "center",
					}, {
						title: 'Name',
						key: 'name'
					},
					{
						title: '星级',
						key: 'start_name'
					},
					{
						title: '状态',
						key: 'status_name'
					},
					{
						title: '锁定客户',
						key: 'is_lock_name'
					},
					{
						title: '客户回收范围',
						key: 'is_redistribute_name'
					},
					{
						title: '时间类型',
						slot: 'timeType',
						align: "center",
					},
					{
						title: '执行时间',
						key: 'execution_time',
						align: "center",
					},
					{
						title: '不回收时间',
						key: 'not_recover_time_name',
						align: "center",
					},
					{
						title: '开关',
						slot: 'is_open',
						align: "center",
					},
					{
						title: '流转地',
						key: 'is_recover_to_pool_name',
						align: "center",
					},
					{
						title: '抽取忽略员工',
						key: 'ignore_uid_name'
					},
					{
						title: '分配忽略员工',
						key: 'distribute_ignore_uid_name'
					},
					{
						title: '更新时间',
						key: 'updated_at'
					},
					{
						title: '创建时间',
						key: 'created_at'
					},
                    {
                        title: 'Action',
                        slot: 'action',
                        width: 150,
                        align: 'center'
                    }
				],
				data1: [],
				myData: {},
				userList: [],
				indeterminate: true,
				checkAll: false,
				indeterminate_distribute: true,
				checkAllDistribute: false,
			}
		},
		methods: {
			async loadData() {
				let that = this;
				let data = {
					token: that.token
				};

				let res = await getClientSet(that, data);
				if (res.code == 1) {
					that.myData = res.data.myData;
				}
				res = await getTeamList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
				}
				res = await getClientRecoverSetList(that, data);
				if (res.code == 1) {
					that.data1 = res.data.list;
				}
			},
			addRule() {
				this.formItem = {};
				this.recoverRuleModal = true;
			},
			appTimeTypeChange(e) {
				this.formItem.apply_time = e;
			},
			remarkTimeTypeChange(e) {
				this.formItem.remark_time = e;
			},
			joinTimeTypeChange(e) {
				this.formItem.join_time = e;
			},
			async adminSet(){
				let that = this;
				that.$Modal.confirm({
					title: '确定要重置吗，如不清楚需先询问负责人',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								is_flush: 1
							}
							let res = await setIsFlush(that, data);
							if (res.code == 1) {
								that.$Message.success(res.msg);
							}
						}, 500)
					}
				})

			},
			saveOpen(e, index) {
				let item = this.data1[index];
				let that = this;
				let data = {
					token: this.token, 
					id: item.id,
					is_open: item.is_open
				};
				this.throttle(async function() {
					let res = await saveClientRecoverSetOpen(that, data);
					if (res.code == 1) {
						that.$Message.success('操作成功');
					}
				}, 200)
			},
			save() {
				let that = this;
				that.throttle(async function() {
					let data = {
						token: that.token,
						data: that.formItem
					};
					let res = await saveClientRecoverSet(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						this.loadData();
					}
				}, 500)
			},
			async editClientRecoverSet(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {token: that.token, id: id};
				let res = await getClientRecoverSet(that, data);
				if (res.code == 1) {
					that.formItem = res.data.item;
					that.recoverRuleModal = true;
					console.log(that.formItem)
				}
			},
			delClientRecoverSet(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async() => {
						that.throttle(async function () {
							let data = {token: that.token, id: id}
							let res = await delClientRecoverSet(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.loadData();
							}
						}, 1000);
					}
				})
			},
			handleCheckAll() {
				if (this.indeterminate) {
					this.checkAll = false;
				} else {
					this.checkAll = !this.checkAll;
				}
				this.indeterminate = false;

				if (this.checkAll) {
					for (let i in this.userList) {
						this.formItem.ignore_uid.push(this.userList[i].id);
					}
				} else {
					this.formItem.ignore_uid = [];
				}
			},
			checkAllGroupChange(data) {
				var userLength = this.userList.length;
				if (data.length === userLength) {
					this.indeterminate = false;
					this.checkAll = true;
				} else if (data.length > 0) {
					this.indeterminate = true;
					this.checkAll = false;
				} else {
					this.indeterminate = false;
					this.checkAll = false;
				}
			},
			handleCheckAllForDistribute() {
				if (this.indeterminate_distribute) {
					this.checkAllDistribute = false;
				} else {
					this.checkAllDistribute = !this.checkAllDistribute;
				}
				this.indeterminate_distribute = false;

				if (this.checkAllDistribute) {
					for (let i in this.userList) {
						this.formItem.distribute_ignore_uid.push(this.userList[i].id);
					}
				} else {
					this.formItem.distribute_ignore_uid = [];
				}
			},
			checkAllGroupChangeForDistribute(data) {
				var userLength = this.userList.length;
				if (data.length === userLength) {
					this.indeterminate_distribute = false;
					this.checkAllDistribute = true;
				} else if (data.length > 0) {
					this.indeterminate_distribute = true;
					this.checkAllDistribute = false;
				} else {
					this.indeterminate_distribute = false;
					this.checkAllDistribute = false;
				}
			},
			saveClientSet() {
			    let that = this;
			    that.throttle(async function () {
			        let data = {
			            token: that.token,
			            data: that.myData
			        };
			        let res = await saveClientSet(that, data);
			        if (res.code == 1) {
			            that.$Message.success(res.msg);
			        }
			    }, 500)
			}
		}
	}
</script>

<style scoped lang="less">
	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 120px;
			height: 20px;
			margin-right: 30px;
			font-weight: bold;
			text-align-last: justify;
		}
	}

	.header {
		display: flex;
		justify-content: space-between;
		padding-top: 10px;
		font-size: 17px;
		font-weight: bold;

		.save {
			padding-right: 50px;
		}
	}

	/deep/ .ivu-table table {
		width: 100% !important;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #FF6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
